<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Penjualan</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Penjualan</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tabmateri" data-toggle="tab">Daftar Pembelian Paket</a>                                                
											</li> 

											<!-- <li class="nav-item">
												<a class="nav-link" href="#tabkategori" data-toggle="tab">Kategori</a>                                                
											</li> 
                                             
											<li class="nav-item">
												<a class="nav-link" href="#tabsubject" data-toggle="tab"><span class="med-records">Subject</span></a>
											</li> -->
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Materi Tab -->
										<div id="tabmateri" class="tab-pane fade show active">
                                            <div class="card card-table">
												<div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-md-2">
                                                            <label>Paket</label>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <!-- <label>Paket</label> -->
                                                            <div class="form-group">
                                                                <v-select
                                                                :options="lstpaket"
                                                                :reduce="lstpaket => lstpaket.id_paket" 
                                                                label="nama_paket"
                                                                v-model="id_paket"
                                                                placeholder="Silahkan pilih Paket"
                                                                required
                                                                />
                                                                
                                                            </div>
                                                        </div>
                                                        <!-- <div class="col-md-3 ">
                                                            <button class="btn btn-primary btn-sm float-left" @click.prevent="getAll()"> Lihat Penjualan Paket </button>
                                                        </div> -->
                                                    </div>
                                                    
                                                    <div class="row">
                                                        <div class="col-md-2">
                                                            <label>Periode</label>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group card-label">
                                                                <select class="form-control select" v-model="waktu">
                                                                    <option value="1" selected>Minggu Ini</option>
                                                                    <option value="2">Bulan Ini</option>
                                                                    <option value="3">Tahun Ini</option>
                                                                    <option value="-1">Semua</option>
                                                                </select>                                                                
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 ">
                                                            <button class="btn btn-primary btn-sm float-left" @click.prevent="getAll()"> Lihat Penjualan Paket </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

											<div class="card card-table mb-0">
												<div class="card-body">

                                                    <!-- <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" @click.prevent="goToBeliPaket()">Beli Paket</a>
                                                    </div> -->
													<div class="table-responsive">
                                                        <table id="tblMateri" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="">Nama User</th>
                                                                    <th class="">Kontak User</th>
                                                                    <th class="">Nama Paket</th>
                                                                    <th class="text-ceter">Tanggal Pembelian</th>
                                                                    <th class="text-center">Batas Pembayaran</th>
                                                                    <th class="text-center">No Invoice</th>
                                                                    <th class="text-center">Nama Referral</th>
                                                                    <th class="text-center">Tanggal Pembayaran</th>
                                                                    <th class="text-center">Status</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lsttransaksi" :key="ref.id_sales">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.namauser }}</td>
                                                                    <td>{{ ref.no_hp }}</td>
                                                                    <td>{{ ref.nama_paket }}</td>
                                                                    <td>{{ (ref.purchase_date!="0000-00-00 00:00:00")?ref.purchase_date:"-" }}</td>
                                                                    <td >{{ (ref.expired_date!="0000-00-00 00:00:00")?ref.expired_date:"-" }}</td>
                                                                    <td>{{ ref.external_id }}</td>
                                                                    <td>{{ ref.namareferral }}</td>
                                                                    <td >{{ (ref.paid_at!="0000-00-00 00:00:00")?ref.paid_at:"-" }}</td>
                                                                    <td class="text-center">
                                                                        <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.inv_status == 'PENDING' , 'bg-success-light' : ref.inv_status == 'PAID', 'bg-danger-light' : ref.inv_status == 'EXPIRED' }">{{ref.inv_status_nm}}</span>
                                                                        <!-- <span :class="{'alert-sm': true, 'alert-warning' : ref.inv_status_nm == 'PENDING' , 'alert-info' : ref.inv_status == 'SETTLED', 'alert-danger' : ref.inv_status == 'EXPIRED' }">{{ref.inv_status_nm}}</span> -->
                                                                    </td>
                                                                    <td>
                                                                        <template v-if="ref.inv_status != 'EXPIRED'">
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="goToInvoice(ref)">
                                                                           Invoice
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-danger-light" depressed small @click="getExpPaket(ref)">
                                                                           Batalkan Pembelian
                                                                        </v-btn>
                                                                        <!-- <v-btn color="btn btn-sm bg-info-light" depressed small @click="mulaiBelajar(ref)">
                                                                           Mulai Belajar
                                                                        </v-btn> -->
                                                                        </template>
                                                                    </td>
                                                                  
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Materi Tab -->
										
										
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        <div id="expMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Batalkan Paket</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan membatalkan paket <b>{{ exp.nama_paket }}</b> user <b>{{ exp.namauser }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="setExpired">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

import $ from 'jquery';
// import moment from "moment";

export default {
    components: {
        Sidebar
    },
	name: 'Materi',
    data() {
        return {
            id_paket: '', waktu: '',
            lstpaket: [],
            lsttransaksi: [],
            exp:{
                id_sales: '',
                nama_paket: '',
                namauser: ''
            },
        }
    },
    created: function () {
        // this.getAllMateri();
        this.getAllPaket();
        // this.getAll();
        // this.getAllSub();
    },  

    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,
                    dom: 'Bfrtip',
                    // buttons: ['copy', 'csv', 'excel', 'pdf', 'print'
                    // ]                    
                    buttons: [
                        { extend: 'copy', className: 'btn btn-sm btn-primary glyphicon glyphicon-duplicate' },
                        { extend: 'csv', className: 'btn btn-sm btn-primary glyphicon glyphicon-save-file' },
                        // { extend: 'excel', className: 'btn btn-sm btn-primary glyphicon glyphicon-list-alt' },
                        // { extend: 'pdf', className: 'btn btn-sm btn-primary glyphicon glyphicon-file' },
                        { extend: 'print', className: 'btn btn-sm btn-primary glyphicon glyphicon-print' }
                    ]
                    // dom: 'Bfrtip',
                    // buttons: [
                    //     'copyHtml5', 'excelHtml5', 'pdfHtml5', 'csvHtml5'
                    // ]

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        goToInvoice: function (ref) {
			localStorage.setItem("idPaket",   ref.id_sales); 
	        if(parseInt(ref.price) >0)
                this.$router.push({name:'admin-paket-belajar-invoice'});//, params: {id: res.data.data}}); 
            else
                this.$router.push({name:'admin-paket-belajar-invoice-gratis'});//, params: {id: res.data.data}}); 
                
        },
        getAllPaket: function () {
            axios.get('api/listnamapaket')
                .then(res => {
                    this.initDt("tblMateri");
                    this.clearTbl("tblMateri");
                    this.lstpaket = res.data.data.paket;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getAll: function () {
            axios.get('api/transaksibyadmin/'+((this.id_paket!="")?this.id_paket:"-1")+'/'+((this.waktu!="")?this.waktu:"-1"))
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblMateri");
                    this.lsttransaksi = res.data.data;
                    this.initDt("tblMateri");
                    // this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Get Delete and Show Confirm Modal
        getExpPaket: function (ref) {
            this.resetVarExp(ref);
            $("#expMdl").modal('show');
        },

        resetVarExp: function(ref){
            if(ref){
                this.exp.id_sales = ref.id_sales;
                this.exp.nama_paket = ref.nama_paket;
                this.exp.namauser = ref.namauser;
            } else {
                this.exp.id_sales =  '';
                this.exp.nama_paket =  '';
                this.exp.namauser =  '';
            }
        },

        // Delete Product
        setExpired: function () {
            axios.post('api/transaksiexp', {
                    id_sales: this.exp.id_sales,
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVarExp();
                    $("#delMdl").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        
 
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Penjualan/index.vue